import { render, staticRenderFns } from "./ModalCarCategoryEdit.vue?vue&type=template&id=35a75b9a&"
import script from "./ModalCarCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ModalCarCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports